<div [formGroup]="form">
    <!-- <div [ngSwitch]="question.controlType">

    <mat-form-field class="example-full-width me-2">
        <mat-label [attr.for]="question.key">{{question.label}}</mat-label>
        <input matInput *ngSwitchCase="'textbox'" [formControlName]="question.key"
        [id]="question.key" [type]="question.type">
        <select [id]="question.key" *ngSwitchCase="'dropdown'" [formControlName]="question.key">
            <option *ngFor="let opt of question.options" [value]="opt.key">{{opt.value}}</option>
          </select>
   
      </mat-form-field>
    </div> -->

    <div [ngSwitch]="question?.controlType">

        <div *ngSwitchCase="'textbox'">
            <!-- <mat-form-field class="example-full-width w-100 me-2" appearance="outline"> -->
            <label *ngIf="question.label != ''" [attr.for]="question.key" class="form-label m-0">{{question.label | translatepipe}}
                <span *ngIf="question.required" class="text_color_red"><sup>*</sup></span></label>
            <input matInput *ngSwitchCase="'textbox'" class="form-control" [placeholder]="question.placeholder"
                [ngClass]="{
                    'is-invalid': (!isValid && isValidt) }" [formControlName]="question.key"
                [id]="question.id == undefined ? question.key : question.id" [type]="question.type"
                (change)="onSelectionChange($event)" [pattern]="question.patterns" [min]="question.Min"
                [max]="question.Max" [minlength]="question.minLength" [maxlength]="question.maxLength"
                [required]="question.required" />

            <!-- <input matInput *ngSwitchCase="'textbox'" class="form-control" [ngClass]="{
                        'is-invalid': (!isValid && isValidt) || patternError }" 
                        [formControlName]="question.key" [id]="question.id == undefined ? question.key : question.id" [type]="question.type"
                        [pattern]="question.patterns" minlength="{{question.minLength}}"
                        maxlength="{{question.maxLength}}" [required]="question.required" /> -->
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'number'" class="">
            <!-- <mat-form-field class="example-full-width w-100 me-2" appearance="outline"> -->
            <label *ngIf="question.label != ''" [attr.for]="question.key" class="form-label">{{question.label | translatepipe}}<span
                    *ngIf="question.required" class="text_color_red"><sup>*</sup></span></label>
            <input matInput *ngSwitchCase="'number'" [ngClass]="{
                        'is-invalid': (!isValid && isValidt) || patternError }" [formControlName]="question.key"
                [id]="question.id == undefined ? question.key : question.id" [type]="question.type"
                [pattern]="question.patterns" minlength="{{question.minLength}}" maxlength="{{question.maxLength}}"
                [required]="question.required">
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'textarea'" class="">
            <!-- <mat-form-field class="example-full-width w-100 me-2" appearance="outline"> -->
            <label *ngIf="question.label != ''" [attr.for]="question.key" class="form-label m-0">{{question.label| translatepipe}}
                <span *ngIf="question.required" class="text_color_red"><sup>*</sup></span></label>
            <textarea class="form-control" matInput *ngSwitchCase="'textarea'" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [formControlName]="question.key" [id]="question.key"
                [type]="question.type" [pattern]="question.patterns" rows="1" minlength="{{question.minLength}}"
                maxlength="{{question.maxLength}}" [required]="question.required"> </textarea>
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'fileupload'" class="">
            <!-- <mat-form-field class="example-full-width w-100 me-2"> -->
            <div class="d-flex justify-content-between">
                <div class="pb-4">
                    <div>
                        <mat-label *ngIf="question.label != ''" [attr.for]="question.key"
                            class="form-label">{{question.label | translatepipe}}</mat-label>
                    </div>
                    <input *ngSwitchCase="'fileupload'" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [formControlName]="question.key" [id]="question.key" type="file"
                        [pattern]="question.patterns" minlength="{{question.minLength}}"
                        maxlength="{{question.maxLength}}" (change)="onSelectFile($event)"
                        [required]="question.required">
                </div>
                <div *ngIf="url">
                    <img [src]="url" width="80px" height="80px" />
                </div>
            </div>
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'dropdown'" class="">
            <!-- <mat-form-field class="w-100 me-2" appearance="outline"> -->
            <label *ngIf="question.label != ''" [attr.for]="question.key" class="form-label m-0">{{question.label  | translatepipe}}
                <span *ngIf="question.required" class="text_color_red"><sup>*</sup></span></label>
            <select class="form-select" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [id]="question.id == undefined ? question.key : question.id"
                *ngSwitchCase="'dropdown'" [formControlName]="question.key" (change)="onSelectionChange($event)"
                [required]="question.required">
                <option selected disabled [value]="null">Choose Options</option>
                <option *ngFor="let opt of question.options" class="py-4" [value]="opt.value">{{question.pipe === false
                    ? opt.key : opt.key | removeUnderscore}}</option>
            </select>
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'objectdropdown'" class="">
            <!-- <mat-form-field class="w-100 me-2" appearance="outline"> -->
            <label *ngIf="question.label != ''" [attr.for]="question.key" class="form-label m-0">{{question.label | translatepipe}}
                <span *ngIf="question.required" class="text_color_red"><sup>*</sup></span></label>
            <select class="form-select" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [id]="question.id == undefined ? question.key : question.id" placeholder="Choose right"
                *ngSwitchCase="'objectdropdown'" [formControlName]="question.key" (change)="onSelectionChange($event)" [required]="question.required">
                <option value=" " disabled selected>Choose Options</option>
                <option *ngFor="let opt of question.options" class="py-4" [value]="opt.id">{{opt.key |
                    removeUnderscore}}</option>
            </select>
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'multiselect'" class="">
            <ng-container *ngIf="question.default">
                <mat-label *ngIf="question.label != ''" [attr.for]="question.key"
                    class="form-label m-0">{{question.label | translatepipe}}
                    <span *ngIf="question.required" class="text_color_red"><sup>*</sup></span></mat-label>
                <mat-select class="form-select" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [id]="question.id == undefined ? question.key : question.id"
                    *ngSwitchCase="'multiselect'" [formControlName]="question.key" [required]="question.required"
                    multiple>
                    <mat-option selected disabled [value]="null">Select Options</mat-option>
                    <mat-option *ngFor="let opt of question.options" [disabled]="opt?.disable"
                        [value]="opt.id">{{opt.key | removeUnderscore}}</mat-option>
                </mat-select>
            </ng-container>

            <ng-container *ngIf="!question.default">
                <!-- <mat-form-field> -->
                <mat-label *ngIf="question.label != ''" [attr.for]="question.key"
                    class="form-label m-0">{{question.label | translatepipe}}
                    <span *ngIf="question.required" class="text_color_red"><sup>*</sup></span></mat-label>
                <mat-select class="form-select" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [id]="question.id == undefined ? question.key : question.id"
                    *ngSwitchCase="'multiselect'" [formControlName]="question.key" [required]="question.required"
                    multiple [compareWith]="comparer">
                    <mat-option *ngFor="let opt of question.options" [disabled]="opt?.disable"
                        [value]="{id : opt.id, name: opt.key, is_selected: opt?.disable}">{{opt.key |
                        removeUnderscore}}</mat-option>
                </mat-select>
                <!-- </mat-form-field> -->
            </ng-container>
        </div>
        <!-- <ng-container > -->
        <div *ngSwitchCase="'checkbox'" class="flex-row ">
            <mat-checkbox *ngSwitchCase="'checkbox'" appearance="outline" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [formControlName]="question.key" [id]="question.key"
                type="checkbox" required>
                <!-- <label *ngIf="question.type === 'checkbox'" class="form-check-label mx-2" [attr.for]="question.key"> -->
                {{question.label | translatepipe}}
                <!-- </label> -->
            </mat-checkbox>
        </div>
        <div *ngSwitchCase="'radio'" class="flex-row ">
            <mat-label *ngIf="question.label != ''" [attr.for]="question.key" [id]="question.key"
                class="form-label m-0">{{question.label}} <span *ngIf="question.required"
                    class="text_color_red"><sup>*</sup></span></mat-label>
            <br />
            <mat-radio-group [ngClass]="{
                'is-invalid': !isValid && isValidt }" [formControlName]="question.key" [id]="question.key"
                type="checkbox">
                <mat-radio-button value="true">Yes</mat-radio-button>
                <mat-radio-button value="false">No</mat-radio-button>
            </mat-radio-group>
        </div>
        <!-- </ng-container> -->
        <div *ngSwitchCase="'datepicker'" class="">
            <!-- <mat-form-field class="w-100" appearance="outline"> -->
            <label *ngIf="question.label != ''" class="form-label m-0">{{question.label | translatepipe}} <span
                    *ngIf="question.required" class="text_color_red"><sup>*</sup></span></label>
            <div class="input-group">
                <input class="form-control" (mousedown)="picker.open();$event.preventDefault()" [matDatepicker]='picker'
                    [formControlName]="question.key" [id]="question.id == undefined ? question.key : question.id"
                    [type]="question.type" [ngClass]="{
                'is-invalid': !isValid && isValidt }" [required]="question.required"
                    (dateChange)="onSelectionChange($event)">
                <mat-datepicker-toggle class="datepicker p-0" [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker class="p-0"></mat-datepicker>
            </div>
            <small class="float-inline-end input_hint" *ngIf="question.label != ''">MM/DD/YYYY</small>
            <!-- </mat-form-field> -->
        </div>
        <div *ngSwitchCase="'timepicker'" class="">
            <label *ngIf="question.label != ''">{{question.label | translatepipe}}
                <span *ngIf="question.required" class="text_color_red">
                    <sup>*</sup>
                </span>
            </label>
            <input matInput type="text" [format]="24" [ngxTimepicker]="picker" [formControlName]="question.key"
                [id]="question.id == undefined ? question.key : question.id" class="form-control"
                [required]="question.required">
            <ngx-material-timepicker #picker class="timepicker"></ngx-material-timepicker>
        </div>

    </div>
    <div *ngIf="isValidt" class="position-relative">
        <!-- <div class="errorMessage" *ngIf="!isValid">{{ question.label }} is required</div> -->
        <div class="fielderrorMessage"
            *ngIf="form.controls[question.key].errors?.['email'] && form.controls[question.key].touched">
            {{ question.label | translatepipe }} <span translate class="ms-1">is not a valid email </span>
        </div>
        <div class="fielderrorMessage"
            *ngIf="form.controls[question.key].errors?.['pattern'] && form.controls[question.key].touched">
           <span translate class="me-1">Please enter a valid </span>{{ question.label | translatepipe}}
        </div>
        <!-- Add more error messages for different validation types as needed -->
        <div class="fielderrorMessage"
            *ngIf="form.controls[question.key].errors?.['required'] && form.controls[question.key].touched">
            <span translate class="me-1">Please enter </span>{{ question.label | translatepipe}}
        </div>
        <!-- <div *ngIf="form.controls[question.key].errors?.['dateOutOfRange'] && form.controls[question.key].touched">
            <p class="error">Please select a date between 2000 and 2025.</p>
          </div> -->
    </div>
</div>